<template>
  <div class="quiz-info-section">
    <div class="quiz-info-head">
      <div class="quiz-order">
        {{ `${order} / ${totalQuiz}` }}
      </div>
    </div>
    <div class="quiz-info-wrapper">
      <div v-if="slide.title" class="quiz-title">
        {{ slide.title }}
      </div>
      <div v-if="slide.image" class="quiz-image">
        <QuizImage
          v-zoom="{
            imgSource: slide.image
          }"
          :src="slide.image && slide.image.thumbnail"
        />
      </div>
    </div>
    <div class="quiz-desc" v-if="slide.titleDesc">
      {{ slide.titleDesc }}
    </div>
  </div>
</template>

<script>
import QuizImage from './QuizImage.vue'

export default {
  components: {
    QuizImage,
  },
  props: {
    slide: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 1,
    },
    totalQuiz: {
      type: Number,
      default: 1,
    },
  },
}
</script>

<style lang="scss" scoped>
.quiz-info-section {
  margin-bottom: 12px;
}

.quiz-info-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.quiz-order {
  align-self: flex-start;
  border-radius: 14px;
  font-size: 14px;
  background: var(--secondary-15, #EFF1F7);
  padding: 4px 8px;
  margin-bottom: 8px;
}

.quiz-title {
  margin-bottom: 12px;
  color: var(--base-90, #313131);
  font-size: 16px;
  font-weight: bold;
}

.quiz-info-wrapper {
  display: grid;
  gap:12px;
  grid-template-columns: 1fr auto;

  .quiz-image {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
